import * as stylex from '@stylexjs/stylex';
import { getDataLabProjectUrl } from '@/dataLab/dataLab.utilities';
import { SeeqNames } from '@seeqdev/constants';
import { faCommentDots } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { fcAnalysis, fcReport, fcSeeqDatalab, fcVantage } from '@seeqdev/icons/seeq';
import { Icon } from '@seeqdev/qomponents';
import type { ICellRendererParams } from '@seeqdev/ag/grid';

export interface UseCaseNameCellProps {
  name: string;
  worksheetId?: string;
  workbookId?: string;
  type?: string;
}

/**
 * This cell-renderer renders a little "bubble" icon next to the use case name to indicate there is more to see and
 * encourage users to click on the cell to see more details.
 * It also includes the workbench icon that links to the associated worksheet in view mode.
 */
export const UseCaseNameCellRenderer = (props: ICellRendererParams<any, UseCaseNameCellProps>) => {
  if (!props?.value) return null;
  const { value } = props;
  if (!value) return null;

  const handleClick = () => {
    if (value.type === SeeqNames.Types.Project && value.workbookId) {
      window.open(getDataLabProjectUrl(value.workbookId), '_blank');
    } else if (value.worksheetId) {
      window.open(`/view/${value.worksheetId}`, '_blank');
    }
  };
  const type = value.type;

  const icon =
    type === SeeqNames.Types.Project
      ? fcSeeqDatalab
      : type === SeeqNames.Types.Vantage
        ? fcVantage
        : type === SeeqNames.Types.Analysis
          ? fcAnalysis
          : fcReport;
  return value.name ? (
    <div {...stylex.props(styles.row)}>
      <div {...stylex.props(styles.name)}>
        <Icon
          testId="typeIcon"
          icon={icon}
          onClick={handleClick}
          extraClassNames="workbookIcon workbenchDisplay"
          xstyle={styles.typeIcon}
        />
        {value.name}
      </div>
      <Icon icon={faCommentDots} extraClassNames="detailsBubble" xstyle={styles.detailsIcon} />
    </div>
  ) : null;
};

const styles = stylex.create({
  row: { display: 'flex', flexDirection: 'row', alignItems: 'center' },
  name: {
    flex: '1 1 auto',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  typeIcon: { marginRight: 5 },
  detailsIcon: { marginLeft: 5 },
});
